export default "/_next/static/chunks/fonts/Raleway Black-2b8d8e1ab965554ae5d252821ca25c90.ttf";